import React from "react";
import { Box } from "@mui/material";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";
import OfferTypeList from "./OfferTypeList";

const OfferTypes: React.FC = () => {
  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => {}} />
      </Box>
      <Box className="dashboardContainer">
        <TopBar />
        <Box sx={{ width: "100%", padding: "20px", marginTop: "5%" }}>
          <OfferTypeList />
        </Box>
      </Box>
    </Box>
  );
};

export default OfferTypes;

